// ════════════════════════════════════════════════════════════════
// WhatsNew — one-shot announcement banner (added 2026-05-04)
// ────────────────────────────────────────────────────────────────
// Surfaces the May 2026 ship list (memory inspector, voice mode,
// transcripts, /why page) to returning users. Slides in from the
// bottom on first eligible page load, dismissable. Re-shows
// only if VERSION below changes.
//
// localStorage key: mvo:whats-new-seen-v1
// ════════════════════════════════════════════════════════════════

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './WhatsNew.css';

const VERSION = '2026-05-04';
const KEY = 'mvo:whats-new-seen-' + VERSION;

export function WhatsNew() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Defer the show by a beat so it doesn't fight the home carousel
    // for visual attention on first paint.
    const t = setTimeout(() => {
      try {
        if (localStorage.getItem(KEY) === '1') return;
        setOpen(true);
      } catch { /* private window — just skip */ }
    }, 1800);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(KEY, '1'); } catch { /* ignore */ }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <aside className="wn-toast" role="status" aria-live="polite">
      <div className="wn-toast-inner">
        <div className="wn-toast-head">
          <span className="wn-toast-eyebrow">New this week</span>
          <button className="wn-toast-x" onClick={dismiss} aria-label="Dismiss">×</button>
        </div>
        <h3 className="wn-toast-title">Memory you can see and pin.</h3>
        <p className="wn-toast-body">
          Each persona now has a 📓 button — tap it to see what's stored,
          pin facts you don't want forgotten, or wipe it clean. Voice mode
          (🔊) speaks replies aloud. And a new public page explains how we
          stack up.
        </p>
        <div className="wn-toast-actions">
          <button
            className="wn-toast-cta"
            onClick={() => { dismiss(); navigate('/why'); }}
          >
            See how we compare →
          </button>
          <button className="wn-toast-skip" onClick={dismiss}>Got it</button>
        </div>
      </div>
    </aside>
  );
}
